import $ from 'jquery';
$(function () {
  var $copyrightYear = $('.footer-copyright-year');
  var currentDate = new Date();
  if (!$copyrightYear || !$copyrightYear.length) {
    return;
  }
  $copyrightYear.text(currentDate.getFullYear());
});